<ion-content class="ion-padding" scrollY="false">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <h2>New version available</h2>
        <p *ngIf="updateStrategy === 'immediate'">Your app is out of date. Please update to the latest version to continue using.</p>
        <p *ngIf="updateStrategy === 'optional'">A new version of the App is available. To get the best experience update now.</p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col *ngIf="updateStrategy === 'optional'">
          <ion-button size="small" expand="block" fill="outline" type="button" (click)="dismiss()">DISMISS
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button size="small" expand="block" strong (click)="update()">UPDATE NOW</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>